import { useEffect, useState } from "react";
import instance from "../../../Interceptor/api_instance";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";

const SelectedStock = ({ data, close }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchDocs = async () => {
      try {
        setLoading(true);
        const res = await instance.get("safety/get-stocklog-file/" + data.id);
        if (res.status === 200) {
          setImages(res.data);
        }
      } catch (err) {
        console.error("Error fetching stock log files:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDocs();
  }, []);
  return (
    <div className="page-mask page-mask-animation">
      <div className="white-cont">
        {loading ? (
          <Spinner />
        ) : (
          <>
            {images.map((img, index) => (
                <div key={img.id} className="image-block">
                    <a
                    href={img.blob_url_sas}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="download-link"
                    >
                    Log File {index}
                    </a>
                </div>
            ))}
            <button className="cancel-btn" onClick={close}>
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SelectedStock;
